<template>
  <div class="acabados">
    <!-- <Transition name="fade" mode="out-in"> -->
    <div :lastKey="activeAcabado.cod" class="acabados__selection">
      <div class="acabados__selection__miniature">
        <img
          :src="requireAsset('tacos/' + activeAcabado.miniature + '.webp')"
          alt=""
          class="acabados__selection__miniature__image"
        />
      </div>
      <div class="acabados__selection__info">
        <span class="acabados__selection__info__acabado">
          {{
            campo
              .getCaracteristica('acabado')
              .getValor(activeAcabado.cod)
              .getLiteral($store.getters.getLanguage)
          }}
        </span>
      </div>
    </div>
    <!-- </Transition> -->
    <div class="acabados__separator">
      <Divider />
      <Button
        :backgroundColor="isModify ? 'rgb(244, 67, 54, 1)' : 'rgb(0, 0, 0, 1)'"
        :hoverBackgroundColor="
          isModify ? 'rgb(244, 67, 54, 0.5)' : 'rgb(0, 0, 0, 0.5)'
        "
        :text="
          getLiteral(
            'lavabo.acabados.' + (isModify ? 'descartar' : 'modificar')
          )
        "
        class="cubetas__caracteristicas__grupos__taladros__item__title__button"
        borderRadius="5px"
        @click="setAcabados"
      />
    </div>
    <!-- </Transition> -->
    <div :lastKey="isModify" v-show="isModify" class="acabados__changes">
      <div class="acabados__changes__filtros">
        <!-- Usamos filtrosModificados para los Select -->
        <div
          v-for="(filtro, filtroIndex) in filtrosModificados"
          :key="filtro.cod + '-' + filtroIndex"
          class="acabados__changes__filtros__item"
        >
          <Select
            :title="filtro.getLiteral($store.getters.getLanguage)"
            :language="$store.getters.getLanguage"
            :icon="requireAsset('iconos/arrow.svg')"
            :valorSel="filtro.valorSel"
            :valores="filtro.valores"
            :activeColor="'black'"
            @valor="
              (valor) =>
                $emit(
                  'filtro',
                  campo.cod,
                  campo.getCaracteristica('acabado').cod,
                  filtro.cod,
                  valor
                )
            "
          />
        </div>
        <div class="acabados__changes__filtros__item">
          <Input
            :referencia="'personalizado'"
            @error="
              () => {
                $emit('error');
              }
            "
            type="text"
            :placeholder="getLiteral('globals.buscar')"
            :valorSel="searchInput"
            @valor="(valor) => setSearchInput(valor)"
          />
        </div>
      </div>
      <div class="acabados__changes__total">
        <span class="acabados__changes__total__values">
          {{
            acabados.length + ' ' + getLiteral('globals.acabados-disponibles')
          }}
        </span>
        <span class="acabados__changes__total__separator"></span>
        <div class="acabados__changes__total__reset" @click="resetFiltros">
          <span class="acabados__changes__total__reset__text">
            {{ getLiteral('globals.ver-todos') }}
          </span>
          <img
            :src="requireAsset('iconos/reset.svg')"
            alt=""
            class="acabados__changes__total__reset__icon"
          />
        </div>
      </div>
      <!-- <Transition name="fade" mode="out-in"> -->
      <div :lastKey="acabados.length" class="acabados__changes__acabados">
        <div
          v-for="(acabado, acabadoIndex) in acabados"
          :key="acabado.cod + '-' + acabadoIndex"
          class="acabados__changes__acabados__item"
          :class="{
            active: acabado.cod == activeAcabado.cod,
            selected:
              acabado.cod == selectedAcabado &&
              activeAcabado.cod != selectedAcabado,
            single: acabados.length == 1,
          }"
        >
          <div class="acabados__changes__acabados__item__miniature">
            <img
              :src="requireAsset('tacos/' + acabado.miniature + '.webp')"
              alt=""
              class="acabados__changes__acabados__item__miniature__image"
              @click="setSelected(acabado)"
            />
            <Button
              class="acabados__changes__acabados__item__miniature__button"
              :backgroundColor="'rgb(0, 0, 0, 1)'"
              :hoverBackgroundColor="'rgb(0, 0, 0, 0.5)'"
              :text="getLiteral('globals.select')"
              borderRadius="5px"
              @click="setActive(acabado)"
            />
          </div>
          <span class="acabados__changes__acabados__item__name">
            {{ acabado.getLiteral($store.getters.getLanguage) }}
          </span>
        </div>
      </div>
      <!-- </Transition> -->
    </div>
    <!-- </Transition> -->
  </div>
</template>

<script>
export default {
  name: 'acabados',
  props: {
    aplicacion: Object,
    campo: Object,
  },
  data() {
    return {
      isModify: false,
      selectedAcabado: '',
      activeAcabado: {
        cod: this.campo.getCaracteristica('acabado').valorSel,
        miniature:
          this.campo.getCaracteristica('acabado').valorSel.split('_')[0] +
          '_' +
          this.campo.getCaracteristica('acabado').valorSel.split('_')[1],
      },
      searchInput: '',
      lastColeccionValor: null,
    };
  },
  computed: {
    seleccion() {
      return this.aplicacion.seleccion[this.aplicacion.getProducto().cod][
        this.aplicacion.getProducto().getModelo().cod
      ];
    },
    condicionBushHammeredDimx() {
      const dimx = Number(this.seleccion?.lavabo?.dimx);
      // If dimx is NOT finite or small (< 1.199), condition is false (allowed)
      if (!Number.isFinite(dimx) || dimx < 1.199) return false;

      const activeValor = this.campo
        .getCaracteristica('acabado')
        .getValor(this.activeAcabado.cod);

      const textura = (activeValor?.filtros?.textura || '').toLowerCase();
      // If Texture is Bush Hammered AND Size is Large (>= 1.199) -> True (Violation)
      return textura === 'bushhammered';
    },
    acabados() {
      const valores = this.campo.getCaracteristica('acabado').valores;
      const filtros = this.campo.getCaracteristica('acabado').filtros;
      const activeFiltros = filtros.filter(
        (filtro) => filtro.valorSel !== 'todos'
      );
      let filteredAcabados =
        activeFiltros.length === 0
          ? valores
          : valores.filter((valorEl) => {
              return activeFiltros.every((filtro) => {
                const filtroValorSel = filtro.valorSel
                  ? filtro.valorSel.toLowerCase()
                  : '';
                const valorElFiltro = valorEl.filtros[filtro.cod]
                  ? valorEl.filtros[filtro.cod].toLowerCase()
                  : '';
                return valorElFiltro === filtroValorSel;
              });
            });
      if (this.searchInput.trim() !== '') {
        const searchLower = this.searchInput.toLowerCase();
        filteredAcabados = filteredAcabados.filter((acabado) =>
          acabado
            .getLiteral(this.$store.getters.getLanguage)
            .toLowerCase()
            .includes(searchLower)
        );
      }
      return filteredAcabados
        .filter((acabadoEl) => acabadoEl.resolveCondicion())
        .filter((acabadoEl) => {
          const dimx = Number(this.seleccion?.lavabo?.dimx);
          const isBig = Number.isFinite(dimx) && dimx >= 1.199;
          const textura = (acabadoEl?.filtros?.textura || '').toLowerCase();
          const coleccion = (acabadoEl?.filtros?.coleccion || '').toLowerCase();

            // Bush Hammered, Kron and Wega NOT allowed if dimx >= 1.199
          if (isBig && (textura === 'bushhammered' || coleccion === 'kron' || coleccion === 'wega')) {
            return false;
          }
          return true;
        });
    },
    bushHammeredAllowed() {
      const dimx = Number(this.seleccion?.lavabo?.dimx);
      return !Number.isFinite(dimx) || dimx < 1.199;
    },
    acabadoCaracteristica() {
      return this.campo.getCaracteristica('acabado');
    },
    filtrosOriginales() {
      return this.acabadoCaracteristica.filtros;
    },
    filtrosModificados() {
      return this.filtrosOriginales.map((filtro) => {
        if (filtro.cod === 'coleccion') {
          return this.buildColeccionFilter(filtro);
        }

        if (filtro.cod === 'textura') {
          return this.buildTexturaFilter(filtro);
        }

        if (filtro.cod === 'tono') {
          return this.buildTonoFilter(filtro);
        }

        return filtro;
      });
    },
    filtrosSyncKey() {
      return this.filtrosModificados
        .map((filtro) => {
          const valoresKey = filtro.valores.map((valor) => valor.cod).join('|');
          return `${filtro.cod}:${filtro.valorSel}:${valoresKey}`;
        })
        .join(';');
    },
  },
  methods: {
    getFilterValor(filterCod) {
      const filtro = this.campo
        .getCaracteristica('acabado')
        .filtros.find((f) => f.cod === filterCod);
      return filtro ? filtro.valorSel : 'todos';
    },
    setSearchInput(valor) {
      this.searchInput = valor;
    },
    buildFiltroView(filtro, valores) {
      return {
        ...filtro,
        valores,
      };
    },
    buildColeccionFilter(filtro) {
      let valores = filtro.valores;

      if (!this.bushHammeredAllowed) {
        valores = valores.filter((opt) => {
          const cod = (opt.cod || '').toLowerCase();
          return cod !== 'kron' && cod !== 'wega';
        });
      }

      return this.buildFiltroView(filtro, valores);
    },
    buildTexturaFilter(filtro) {
      const coleccionSel = this.getFilterValor('coleccion');
      let valores = filtro.valores;

      if (!this.bushHammeredAllowed) {
        valores = valores.filter(
          (opt) => (opt.cod || '').toLowerCase() !== 'bushhammered'
        );
      }

      if (coleccionSel !== 'todos') {
        valores = valores.filter((option) => {
          if (option.cod === 'todos') return true;

          if (
            option.coleccionesCompatible &&
            Array.isArray(option.coleccionesCompatible)
          ) {
            return option.coleccionesCompatible.includes(coleccionSel);
          }

          return true;
        });
      }

      return this.buildFiltroView(filtro, valores);
    },
    buildTonoFilter(filtro, overrides = {}) {
      const coleccionSel =
        overrides.coleccionSel || this.getFilterValor('coleccion');
      const texturaSel = overrides.texturaSel || this.getFilterValor('textura');
      let valores = filtro.valores;

      if (coleccionSel !== 'todos' || texturaSel !== 'todos') {
        valores = valores.filter((option) => {
          if (option.cod === 'todos') return true;

          const coleccionOk =
            coleccionSel === 'todos' ||
            !option.coleccionesCompatible ||
            !Array.isArray(option.coleccionesCompatible) ||
            option.coleccionesCompatible.includes(coleccionSel);

          const texturaOk =
            texturaSel === 'todos' ||
            !option.texturasCompatible ||
            !Array.isArray(option.texturasCompatible) ||
            option.texturasCompatible.includes(texturaSel);

          return coleccionOk && texturaOk;
        });
      }

      return this.buildFiltroView(filtro, valores);
    },
    syncFiltros(filtros, options = {}) {
      filtros.forEach((filtro) => {
        const valores = this.getValoresParaSync(filtro, options);
        const opcionesSinTodos = valores.filter(
          (option) => option.cod !== 'todos'
        );

        if (opcionesSinTodos.length === 1) {
          this.setFiltroValor(filtro.cod, opcionesSinTodos[0].cod);
          return;
        }

        if (
          options.resetDependientes &&
          this.isFiltroDependienteColeccion(filtro)
        ) {
          this.setFiltroValor(filtro.cod, 'todos');
          return;
        }

        if (this.shouldResetInvalidFilter(filtro)) {
          this.setFiltroValor(filtro.cod, 'todos');
        }
      });
    },
    getValoresParaSync(filtro, options) {
      if (options.resetDependientes && filtro.cod === 'tono') {
        return this.buildTonoFilter(filtro, { texturaSel: 'todos' }).valores;
      }

      return filtro.valores;
    },
    isFiltroDependienteColeccion(filtro) {
      return filtro.cod === 'textura' || filtro.cod === 'tono';
    },
    shouldResetInvalidFilter(filtro) {
      if (filtro.cod === 'coleccion') return false;

      return !filtro.valores.some((option) => option.cod === filtro.valorSel);
    },
    setFiltroValor(filtroCod, valor) {
      const filtro = this.filtrosOriginales.find(
        (item) => item.cod === filtroCod
      );

      if (!filtro || filtro.valorSel === valor) return;

      filtro.valorSel = valor;

      this.$emit(
        'filtro',
        this.campo.cod,
        this.acabadoCaracteristica.cod,
        filtro.cod,
        valor
      );
    },
    resetFiltros() {
      this.filtrosOriginales.forEach((filtro) => {
        this.setFiltroValor(filtro.cod, 'todos');
      });
      this.searchInput = '';
    },
    setAcabados() {
      this.isModify = !this.isModify;
      if (!this.isModify) {
        this.selectedAcabado = this.activeAcabado.cod;
        this.setValor(this.activeAcabado.cod);
      }
    },
    setActive(acabado) {
      this.activeAcabado = {
        cod: acabado.cod,
        miniature: acabado.cod.split('_')[0] + '_' + acabado.cod.split('_')[1],
      };
      this.setAcabados();
    },
    setSelected(acabado) {
      this.selectedAcabado = acabado.cod;
      this.setValor(acabado.cod);
    },
    setValor(acabado) {
      this.$emit(
        'valor',
        this.campo.cod,
        this.campo.getCaracteristica('acabado').cod,
        acabado
      );
    },
  },
  watch: {
    filtrosSyncKey: {
      handler() {
        const coleccionValor = this.getFilterValor('coleccion');
        const coleccionChanged =
          this.lastColeccionValor !== null &&
          coleccionValor !== this.lastColeccionValor;

        this.lastColeccionValor = coleccionValor;
        this.syncFiltros(this.filtrosModificados, {
          resetDependientes: coleccionChanged,
        });
      },
      immediate: true,
    },
    acabados(newAcabados) {
      const activeExists = newAcabados.some(
        (a) => a.cod === this.activeAcabado.cod
      );
      if (!activeExists) {
        const THRESHOLD = 1.199;
        const dimx = Number(this.seleccion?.lavabo?.dimx);
        if (!Number.isFinite(dimx) || dimx < THRESHOLD) return;

        const allValores = this.campo.getCaracteristica('acabado').valores;
        const activeValor = allValores.find(
          (v) => v.cod === this.activeAcabado.cod
        );
        if (!activeValor) return;

        const texturaCod = (activeValor?.filtros?.textura || '').toLowerCase();
        const coleccionCod = (activeValor?.filtros?.coleccion || '').toLowerCase();
        const isRestricted =
          texturaCod === 'bushhammered' ||
          coleccionCod === 'kron' ||
          coleccionCod === 'wega';

        if (!isRestricted) return;

        const acabadoNombre = activeValor.getLiteral(
          this.$store.getters.getLanguage
        );
        const step =
          this.campo.getCaracteristica('dimx')?.getStep() || 0.001;
        const closestSize = Math.round((THRESHOLD - step) * 1000) / 1000;
        const maxMm = Math.round(THRESHOLD * 1000);
        const sizeMm = Math.round(closestSize * 1000);

        const message = this.getLiteral('acabados.info.no_disponible_medida')
          .replace('{acabado}', acabadoNombre)
          .replace('{max}', sizeMm)
          .replace('{size}', sizeMm);

        this.$root.$emit('popup', message);
        this.$emit('valor', this.campo.cod, 'dimx', closestSize);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.acabados {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  gap: 10px;
  &__selection {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    gap: 5px;
    &__miniature {
      width: 150px;
      height: 50px;
      border-radius: 5px;
      &__image {
        border-radius: 5px;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    &__info {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      height: 100%;
      &__acabado {
        font-size: 16px;
        font-weight: 600;
      }
    }
  }
  &__separator {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    gap: 5px;
  }
  &__changes {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    &__filtros {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-end;
      flex-wrap: wrap;
      width: 100%;
      gap: $caracteristicaGap;
      // &__item {
      // }
    }
    &__total {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 10px;
      gap: 7.5px;
      &__values {
        font-size: 14px;
      }
      &__separator {
        width: 0.01em;
        height: 14px;
        background-color: black;
      }
      &__reset {
        cursor: pointer;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        gap: 2.5px;
        &__text {
          font-size: 14px;
        }
        &__icon {
          width: 20px;
          height: 20px;
          object-fit: contain;
        }
      }
    }
    &__acabados {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
      gap: 25px;
      width: 100%;
      margin-top: 20px;
      &__item {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        width: 100%;
        height: 50%;
        min-height: 50px;
        border-radius: 5px;
        &__miniature {
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          width: 100%;
          height: 50px;
          min-height: 50px;
          border-radius: 5px;
          padding: 0px;
          border: 2px solid transparent;
          transition:
            0.35s ease-in-out border,
            0.35s ease-in-out padding;
          &__image {
            filter: brightness(100%);
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 5px;
            transition: 0.35s ease-in-out filter;
          }
          &__button {
            cursor: pointer;
            position: absolute;
            opacity: 0;
            pointer-events: none;
            transition: 0.35s ease-in-out all;
          }
        }
        &__name {
          margin-top: 5px;
          font-size: 13px;
          font-weight: 400;
        }
        &.active {
          & .acabados__changes__acabados__item {
            &__miniature {
              pointer-events: none;
              border: 2px solid black;
              padding: 5px;
              transition:
                0.35s ease-in-out border,
                0.35s ease-in-out padding;
            }
          }
        }
        &.selected {
          & .acabados__changes__acabados__item {
            &__miniature {
              &__button {
                opacity: 1;
                pointer-events: visible;
                transition: 0.35s ease-in-out all;
              }
            }
          }
        }
        &:not(.active):not(.selected) {
          & .acabados__changes__acabados__item {
            &__miniature {
              &:hover {
                & .acabados__changes__acabados__item__miniature {
                  &__image {
                    filter: brightness(75%);
                    transition: 0.35s ease-in-out filter;
                  }
                }
              }
            }
          }
        }
        &.single {
          max-width: 350px;
        }
      }
    }
  }
}
</style>
